import React from "react";
import { Button } from "@/components/ui/button";
import { 
  MapPin, 
  ArrowRight, 
  Navigation, 
  Loader2 
} from "lucide-react";

/**
 * Card for available deliveries that partners can claim
 */
export function AvailableDeliveryCard({ delivery, onClaim, claiming }) {
  return (
    <div className="border border-border p-6 bg-green-50/30">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="flex items-center gap-2 font-bold text-lg mb-1">
            <MapPin className="w-4 h-4 text-green-600" />
            <span>{delivery.pickup_address}</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <ArrowRight className="w-4 h-4" />
            <MapPin className="w-4 h-4 text-red-500" />
            <span>{delivery.drop_address}</span>
          </div>
        </div>
        <div className="text-right">
          <p className="font-bold text-lg text-green-600">₹{delivery.final_price}</p>
          <p className="text-sm text-muted-foreground">{delivery.vehicle_type}</p>
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="text-sm text-muted-foreground">
          <span>Package: {delivery.package_category}</span>
          {delivery.distance_km && <span> • {delivery.distance_km} km away</span>}
        </div>
        <Button
          onClick={() => onClaim(delivery.id)}
          disabled={claiming === delivery.id}
          className="rounded-none bg-green-600 hover:bg-green-700"
          data-testid={`claim-${delivery.id}`}
        >
          {claiming === delivery.id ? (
            <Loader2 className="w-4 h-4 animate-spin mr-2" />
          ) : (
            <Navigation className="w-4 h-4 mr-2" />
          )}
          Claim Pickup
        </Button>
      </div>
    </div>
  );
}
